import { render, staticRenderFns } from "./sales-by-customer.vue?vue&type=template&id=76d31b5c"
import script from "./sales-by-customer.vue?vue&type=script&lang=js"
export * from "./sales-by-customer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports